import React, { Component } from "react";
import CssClasses from "./PrematchEventList.css";
import EventGroupItem from "../../Components/EventGroupItem/EventGroupItem";
import { connect } from "react-redux";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import * as MostPlayedOptionIDs from "../../HOCs/Constants/MostPlayedOptionID";

//let eventItems = [];

import {
  GetPairsForBetType,
  GetBetDetails,
  GetTicketPairs
} from "../../Communication/PrematchInfoServicesHandler";
import { ConvertLanguageCodeToJezikID } from "../../HOCs/Helpers/LanguageConverter";

let moment = require("moment");

class PrematchEventList extends Component {
  _isFetchingInProgress = false;

  state = {
    currentBetInfo: null,
    matchGroups: null
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("CIMPONEN DID UPDATE!!!!");
    console.log(prevProps);

    //pogledaj je li se promjenio propertys
    //ili ako jos nema nista
    if (
      ((prevProps.currentPrematchSportID !==
        this.props.currentPrematchSportID ||
        !this.state.currentBetInfo) &&
        this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.PREMATCH) ||
      ((this.props.eventItems
        ? this.props.eventItems.length !== prevProps.eventItems.length
        : true) &&
        !this._isFetchingInProgress)
    ) {
      this.props.startLoading(true, false);

      this._isFetchingInProgress = true;

      console.log("PODESAVAM ALL BETS TEXT!");

      if (this.state.currentBetInfo) {
        //promjena sporta pa brisi
        this.setState({
          currentBetInfo: null
        });
      }

      if (this.props.allBetsText) {
        //mici i sva 1x2 reg vrijeme zasade ovako
        //170 tenis pobjednik, 172 1.set pobjednik
        //99 basket konacni pobjednik
        //430 basket broj koseva igraca
        var bets1x2 = [287, 287, 329, 336, 318, 112, 117, 170, 172, 99, 430];

        let betTypeButtons = this.props.allBetsText.filter(
          x =>
            x.SportID === this.props.currentPrematchSportID &&
            !bets1x2.includes(x.IDOkladaVrsta)
        );

        //uzmi prvi btn
        if (betTypeButtons.length > 0) {
          //brisi i matches na tvornicko
          if (this.state.matchGroups) {
            this.setState({ matchGroups: null });
          }

          var btn = betTypeButtons[0];

          let id = btn.IDOkladaVrsta;

          if (id === 11) {
            id = 3; //nogomet, umjesto zbroj golova multi odaberi oba daju gol
          }

          if (id === 423) {
            id = 177; //tenis, umjesto hendikep gemova odaberi tocan rezultat
          }

          //dohvati betinfo za to
          GetBetDetails(
            ConvertLanguageCodeToJezikID(this.props.currentLanguage),
            id,
            this.getBetDetails_Callback.bind(this)
          );

          let tmpDate = new Date();

          //dohvati i kvote
          GetPairsForBetType(
            moment(this.props.chosenDate)
              .add(tmpDate.getTimezoneOffset(), "m")
              .toDate(),
            ConvertLanguageCodeToJezikID(this.props.currentLanguage),
            id,
            tmpDate.getTimezoneOffset(),
            0,
            this.getPairsForBetType_Callback.bind(this)
          );
        } else {
          //nema dodatnih betova, rokaj kako je
          this.props.stopLoading(false);

          if (this.state.matchGroups) {
            //provjeri da ih ima
            if (
              this.state.matchGroups.length > 0 &&
              this.props.eventItems.length > 0
            ) {
              //dohvati prve
              var t1 = this.state.matchGroups[0];
              var t2 = this.props.eventItems[0];

              //ako su razliciti sportovi, gazi
              if (t1.sportID !== t2.sportID) {
                this.setState({ matchGroups: this.props.eventItems });
                console.log("groups ", this.state.matchGroups);
              }
            }
          }
        }
      }

      //promjenio se sport, dohvati sve dodatne oklade za taj sport

      //i priopr
    }
  }

  getPairsForBetType_Callback = (data, betTypeID) => {
    console.log("IN CALLBACK FOR getPairsForBetType_Callback WITH DATA ", data);

    this.props.stopLoading();
    this._isFetchingInProgress = false;

    if (!data) {
      console.log("NO DATA!");
      return;
    }

    //pripremi si kopiju utakmica iz propsa
    var originalMatches = JSON.parse(JSON.stringify(this.props.eventItems));

    console.log("ORIGINAL ARE ", originalMatches);

    //nadodaj kvote
    originalMatches.forEach(group => {
      group.matches.forEach(match => {
        //nadji zapis
        var pair = data.find(x => x.IDPar === match.id);

        if (pair) {
          //nabaci kvote
          let betInfo = [];

          //dohvati kvote
          var kvote = pair.KvotaList;
          var tmpMargin = "";

          //za svaku kvotu salji u bet info
          kvote.forEach(kv => {
            betInfo.push({
              betID: kv.IDParKvota,
              changeDirection: 0,
              id: kv.IDParKvota,
              isActive: true,
              isEnabled: true,
              isShown: true,
              kategorijaPonudeID: betTypeID,
              longName: kv.Tip,
              matchID: pair.IDPar,
              order: 0,
              shortName: kv.Tip,
              sportVrstaOkladaID: betTypeID,
              value: kv.KvotaVrijednost,
              margin: kv.Margina
            });

            tmpMargin = kv.Margina; //nebitno od koje je kad su sve iste
          });

          match.margin = tmpMargin;
          match.betInfo = match.betInfo.concat(betInfo);
        }
      });
    });

    // //obradi
    // let tmpDate = new Date();
    // var matches = [];

    // filtered.forEach(pair => {
    //   console.log("OBRADA ZA ", pair);

    //   let betInfo = [];
    //   let isSuperTip = false;

    //   //dohvati kvote
    //   var kvote = pair.KvotaList;
    //   var tmpMargin = "";

    //   //za svaku kvotu salji u bet info
    //   kvote.forEach(kv => {
    //     betInfo.push({
    //       betID: kv.IDParKvota,
    //       changeDirection: 0,
    //       id: kv.IDParKvota,
    //       isActive: true,
    //       isEnabled: true,
    //       isShown: true,
    //       kategorijaPonudeID: betTypeID,
    //       longName: kv.Tip,
    //       matchID: pair.IDPar,
    //       order: 0,
    //       shortName: kv.Tip,
    //       sportVrstaOkladaID: betTypeID,
    //       value: kv.KvotaVrijednost,
    //       margin: kv.Margina
    //     });

    //     tmpMargin = kv.Margina; //nebitno od koje je kad su sve iste

    //     if (kv.SuperTip === 1) {
    //       isSuperTip = true;
    //     }
    //   });

    //   // betInfo.forEach(bi => {
    //   //   console.log("BETINFO IS ", bi);
    //   //   console.log("PARSED DILDO IS ", parseFloat(bi.margin));
    //   // });

    //   matches.push({
    //     id: pair.IDPar,
    //     homeTeam: pair.DomacinNaziv,
    //     guestTeam: pair.GostNaziv,
    //     startTime: moment(pair.DatumUtakmice)
    //       .add(-tmpDate.getTimezoneOffset(), "m")
    //       .toDate(),
    //     betInfo: betInfo,
    //     isSuperTip: isSuperTip,
    //     sportID: this.props.currentSportID, //pair.SportID vraca 0, ide kemija
    //     betRadarID: pair.BrMatchID,
    //     betTypeID: this.state.currentActiveBetTypeID,
    //     numberOfExtraBets: pair.BrojOklada,
    //     margin: tmpMargin
    //   });
    // });

    // console.log("NOVE MATCHES SU ", matches);
    // console.log("MATCHES U STATEU SU ", this.state.customMatchesToShow);

    //this.setState({ customMatchesToShow: matches });
    console.log("PROCESSED ARE ", originalMatches);

    this.setState({ matchGroups: originalMatches });
  };

  getBetDetails_Callback(data, betTypeID) {
    console.log("IN CALLBACK FOR getBetDetails_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      return;
    }

    data.VrstaOkladeID = betTypeID;

    this.setState({ currentBetInfo: data });
  }

  storageHandler = event => {
    console.log("Storage event for key: ", event.key);
    if (event.key === LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS) {
      //pozovi event
      this.ticketItemStateChangedHandler();
    }
  };

  ticketItemStateChangedHandler = () => {
    //dohvati iz storagea
    var ticketInfo = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS)
    );

    console.log(
      "PREMATCH: Received ticket items from LocalStorage! " + new Date()
    );

    //i spremi u state
    this.props.onRestoreTicketStateFromLocalStorage(ticketInfo);
  };

  componentWillMount() {
    //this.fillDummyData();

    //pretplati se na promjenu
    window.addEventListener("storage", this.storageHandler, false);
  }

  render() {
    //filtriraj iteme
    // let filteredItems = eventItems.filter(
    //   x => x.sportID === this.props.currentPrematchSportID
    // );
    let filteredItems = null;

    if (this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.PREMATCH) {
      filteredItems = this.state.matchGroups; //this.props.eventItems;
    } else {
      filteredItems = this.props.eventItems;
    }

    let containerClasses = [CssClasses.container];

    if (
      this.props.prematchExtraBetsID > 0 ||
      this.props.currentActionButton > 0
    ) {
      containerClasses.push(CssClasses.showsExtraBets);
    } else {
      if (this.props.shouldQuickCloseExtraBets) {
        containerClasses.push(CssClasses.quickHidesExtraBets);
      } else {
        containerClasses.push(CssClasses.hidesExtraBets);
      }
    }

    if (!filteredItems) {
      return <div className={containerClasses.join(" ")}>&nbsp;</div>;
    }

    return (
      <div className={containerClasses.join(" ")}>
        {filteredItems.map(eventInfo => {
          return (
            <EventGroupItem
              key={eventInfo.id}
              eventInfo={eventInfo}
              currentSportID={this.props.currentPrematchSportID}
              initialMiddleBetInfo={this.state.currentBetInfo}
            />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentPrematchSportID: state.rrNavigation.prematchSportID,
    prematchExtraBetsID: state.rrNavigation.prematchExtraBetsID,
    currentActionButton: state.rrNavigation.currentActionButton,
    shouldQuickCloseExtraBets: state.rrNavigation.shouldQuickCloseExtraBets,
    allBetsText: state.rrSportEvent.allBetsText,
    currentLanguage: state.rrAppState.currentLanguage,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRestoreTicketStateFromLocalStorage: ticketState =>
      dispatch(StoreActions.RestoreTicketStateFromLocalStorage(ticketState)),
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrematchEventList);



// WEBPACK FOOTER //
// ./src/Containers/PrematchEventList/PrematchEventList.js